<template>
 <div class="route-table">

    <p class="date">
      {{ Reservation.pickUpTime.split(/[-T]/)[0] }}年{{
        Reservation.pickUpTime.split(/[-T]/)[1]
      }}月{{ Reservation.pickUpTime.split(/[-T]/)[2] }}日
    </p>

    <displayTimeAndBusstop v-if="selectedService" 
    :time="Reservation.estimatePickUpTime" 
    :busstopName="Reservation.pickUpBusstopName" 
    :depart="true"/>
    <displayTimeAndBusstop v-else 
    :time="Reservation.latestEstimatePickUpTime" 
    :busstopName="Reservation.pickUpBusstopName" 
    :depart="true"/>
    

    <div class="white-bg">
      <div style="z-index: 1">
        <span class="circle blue-line" style="background: white"></span>
        <span v-if="selectedService" style="margin-left: 30%">{{selectedService.name}}</span>
      </div>
    </div>

    <displayTimeAndBusstop v-if="selectedService" 
    :time="Reservation.estimateDropOffTime" 
    :busstopName="Reservation.dropOffBusstopName" />
    <displayTimeAndBusstop v-else 
    :time="Reservation.latestEstimateDropOffTime" 
    :busstopName="Reservation.dropOffBusstopName" />
    
  </div>
</template>

<script>
export default {
  name: "routeTable",
  props:{
    selectedService:{
      type: Object,
      require: false,
      default: null
    },
    Reservation:{
      type: Object,
      require: true
    },
  },
  setup() {
   
  }
};
</script>

<style lang="scss">
.route-table {
  margin: 20px 0;
}
.date {
  margin-left: 15px;
  margin-bottom: 5px;
}

.white-bg {
  background: #f9f9f9;
  padding: 0;
  padding-left: 10px;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  height: 35px;
  position: relative;
  background: white; 
  border: none
}

.white-bg div {
  position: absolute;
  top: 50%;
  width: 95%;
  transform: translate(0%, -50%);
  -webkit-transform: translate(0%, -50%);
  -ms-transform: translate(0%, -50%);
}

.blue-line {
  background: white;
}

.blue-line::before {
  content: "";
  content: "";
  left: calc(25% - -4px);
  position: relative;
  background: #2a7aff;
  border-right: 3px solid transparent;
  border-bottom: 18px solid transparent;
  border-top: 16px solid transparent;
}
</style>